import { __rest } from 'tslib';
import React from 'react';
import { useTheme } from '@10d/tend-ui-theme';
import cn from 'classnames';
import { Root } from './styled.js';

const Em = React.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-em' }, props, { ref: ref, theme: useTheme(), className: cn(['tend-ui-typography-em', className]) })));
});
Em.displayName = 'Em';

export { Em };
//# sourceMappingURL=Em.js.map
